import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "card validation-card" }
const _hoisted_2 = { class: "card-head d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "filters" }
const _hoisted_4 = { class: "btn-group me-2" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row g-3 mb-4" }
const _hoisted_7 = { class: "stat-card" }
const _hoisted_8 = { class: "stat-value" }
const _hoisted_9 = { class: "stat-label" }
const _hoisted_10 = {
  key: 0,
  class: "bulk-bar"
}
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_13 = {
  key: 0,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_14 = ["checked"]
const _hoisted_15 = {
  key: 1,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["colspan"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "muted" }
const _hoisted_24 = {
  key: 1,
  class: "muted"
}
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "muted" }
const _hoisted_28 = {
  key: 1,
  class: "muted"
}
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_31 = {
  key: 1,
  class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
}
const _hoisted_32 = { class: "dropdown" }
const _hoisted_33 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_37 = {
  class: "modal fade",
  id: "validationModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_38 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_39 = { class: "modal-content" }
const _hoisted_40 = { class: "modal-header" }
const _hoisted_41 = { class: "modal-title" }
const _hoisted_42 = { class: "modal-body" }
const _hoisted_43 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_44 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_45 = { class: "mb-3" }
const _hoisted_46 = { class: "form-label" }
const _hoisted_47 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = { class: "modal-footer" }
const _hoisted_50 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("div", null, [
        _createElementVNode("h4", { class: "title" }, "Validation des dossiers"),
        _createElementVNode("p", { class: "subtitle" }, "Supervision et contrôle des validations agents")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn btn-sm", _ctx.viewMode === 'PENDING' ? 'btn-primary' : 'btn-outline-primary']),
            onClick: _cache[0] || (_cache[0] = () => { _ctx.viewMode = 'PENDING'; _ctx.loadValidations(); })
          }, " En attente ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["btn btn-sm", _ctx.viewMode === 'PROCESSED' ? 'btn-primary' : 'btn-outline-primary']),
            onClick: _cache[1] || (_cache[1] = () => { _ctx.viewMode = 'PROCESSED'; _ctx.loadValidations(); })
          }, " Traités ", 2)
        ]),
        _createVNode(_component_Multiselect, {
          class: "filter-select",
          modelValue: _ctx.selectedAgent,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedAgent) = $event)),
          options: _ctx.agentOptions,
          placeholder: "Agent",
          onChange: _cache[3] || (_cache[3] = () => _ctx.loadValidations())
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_Multiselect, {
          class: "filter-select",
          modelValue: _ctx.selectedQueue,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedQueue) = $event)),
          options: _ctx.queueOptions,
          placeholder: "File",
          onChange: _cache[5] || (_cache[5] = () => _ctx.loadValidations())
        }, null, 8, ["modelValue", "options"]),
        _createElementVNode("button", {
          class: "btn btn-outline-primary btn-sm",
          onClick: _cache[6] || (_cache[6] = () => _ctx.loadValidations())
        }, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("i", { class: "flaticon-refresh" }, null, -1)
        ]))])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statsUI, (stat) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-3",
            key: stat.label
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(["stat-icon", stat.type])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(stat.icon)
                }, null, 2)
              ], 2),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(stat.value), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(stat.label), 1)
              ])
            ])
          ]))
        }), 128))
      ]),
      (_ctx.viewMode === 'PENDING' && _ctx.selectedValidations.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("span", null, [
              _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-info" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.selectedValidations.length) + " dossier(s) sélectionné(s) ", 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-success btn-sm",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openModalBulk('APPROVED')))
              }, [...(_cache[17] || (_cache[17] = [
                _createElementVNode("i", { class: "flaticon-check" }, null, -1),
                _createTextVNode(" Approuver ", -1)
              ]))]),
              _createElementVNode("button", {
                class: "btn btn-warning btn-sm",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openModalBulk('REJECTED')))
              }, [...(_cache[18] || (_cache[18] = [
                _createElementVNode("i", { class: "flaticon-close" }, null, -1),
                _createTextVNode(" Rejeter ", -1)
              ]))]),
              _createElementVNode("button", {
                class: "btn btn-light btn-sm",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)))
              }, " Annuler ")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("table", _hoisted_12, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_ctx.viewMode === 'PENDING')
                ? (_openBlock(), _createElementBlock("th", _hoisted_13, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                      checked: _ctx.isAllSelected
                    }, null, 40, _hoisted_14)
                  ]))
                : _createCommentVNode("", true),
              _cache[19] || (_cache[19] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "BESC", -1)),
              _cache[20] || (_cache[20] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Agent", -1)),
              _cache[21] || (_cache[21] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "File", -1)),
              _cache[22] || (_cache[22] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Terminé", -1)),
              _cache[23] || (_cache[23] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Statut", -1)),
              (_ctx.viewMode === 'PENDING')
                ? (_openBlock(), _createElementBlock("th", _hoisted_15, " Actions "))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (!_ctx.validations.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                  _createElementVNode("td", {
                    colspan: _ctx.viewMode === 'PENDING' ? 7 : 5,
                    class: "text-center text-muted py-4"
                  }, [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("i", { class: "flaticon-folder-open" }, null, -1),
                    _createElementVNode("p", null, "Aucune validation trouvée", -1)
                  ]))], 8, _hoisted_17)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validations, (v) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: v.id
              }, [
                (_ctx.viewMode === 'PENDING')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedValidations) = $event)),
                        value: v.id
                      }, null, 8, _hoisted_19), [
                        [_vModelCheckbox, _ctx.selectedValidations]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_20, [
                  _createElementVNode("strong", null, _toDisplayString(v.refbesc), 1)
                ]),
                _createElementVNode("td", _hoisted_21, [
                  (v.assignedAgent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createTextVNode(_toDisplayString(v.assignedAgent.nom) + " " + _toDisplayString(v.assignedAgent.prenom) + " ", 1),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(v.assignedAgent.email), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_24, "—"))
                ]),
                _createElementVNode("td", _hoisted_25, [
                  (v.queue)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createTextVNode(_toDisplayString(v.queue.name) + " ", 1),
                        _createElementVNode("div", _hoisted_27, _toDisplayString(v.queue.code), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_28, "—"))
                ]),
                _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.viewMode === 'PENDING' 
                  ? _ctx.format_date(v.completedAt) 
                  : _ctx.format_date(v.supervisorValidatedAt)), 1),
                _createElementVNode("td", _hoisted_30, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", _ctx.statusClass(v.supervisorDecision)])
                  }, _toDisplayString(_ctx.statusLabel(v.supervisorDecision)), 3)
                ]),
                (_ctx.viewMode === 'PENDING')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _cache[27] || (_cache[27] = _createElementVNode("span", {
                          class: "badge text-white bg-primary fs-15 dropdown-toggle",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false",
                          style: {"cursor":"pointer"}
                        }, [
                          _createTextVNode(" Actions "),
                          _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                        ], -1)),
                        _createElementVNode("ul", _hoisted_33, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.openModalSingle(v, 'APPROVED')), ["prevent"])
                            }, [...(_cache[25] || (_cache[25] = [
                              _createElementVNode("i", { class: "flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Approuver ", -1)
                            ]))], 8, _hoisted_34)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.openModalSingle(v, 'REJECTED')), ["prevent"])
                            }, [...(_cache[26] || (_cache[26] = [
                              _createElementVNode("i", { class: "flaticon-close lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Rejeter ", -1)
                            ]))], 8, _hoisted_35)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("h5", _hoisted_41, _toDisplayString(_ctx.modalData.decision === 'APPROVED' ? 'Approuver' : 'Rejeter') + " " + _toDisplayString(_ctx.modalData.isBulk ? 'les dossiers' : 'le dossier'), 1),
            _cache[28] || (_cache[28] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_42, [
            (_ctx.modalData.isBulk)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createTextVNode(" Vous êtes sur le point de " + _toDisplayString(_ctx.modalData.decision === 'APPROVED' ? 'approuver' : 'rejeter') + " ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.selectedValidations.length), 1),
                  _cache[29] || (_cache[29] = _createTextVNode(" dossier(s). ", -1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _cache[30] || (_cache[30] = _createTextVNode(" Dossier : ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.modalData.validation?.refbesc), 1)
                ])),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", _hoisted_46, [
                _cache[31] || (_cache[31] = _createTextVNode(" Commentaire ", -1)),
                (_ctx.modalData.decision === 'REJECTED')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, "*"))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalData.comment) = $event)),
                class: "form-control",
                rows: "4",
                placeholder: _ctx.modalData.decision === 'APPROVED' ? 'Commentaire optionnel...' : 'Veuillez préciser la raison du rejet...'
              }, null, 8, _hoisted_48), [
                [_vModelText, _ctx.modalData.comment]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _cache[32] || (_cache[32] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              "data-bs-dismiss": "modal"
            }, "Annuler", -1)),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn", _ctx.modalData.decision === 'APPROVED' ? 'btn-success' : 'btn-warning']),
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.confirmValidation && _ctx.confirmValidation(...args))),
              disabled: _ctx.modalData.decision === 'REJECTED' && !_ctx.modalData.comment.trim()
            }, _toDisplayString(_ctx.modalData.decision === 'APPROVED' ? 'Approuver' : 'Rejeter'), 11, _hoisted_50)
          ])
        ])
      ])
    ])
  ]))
}